(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lpl75", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $f95c4f742b3ffbfa$export$6503ec6e8aabbaf; }, function (v) { return $f95c4f742b3ffbfa$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $f95c4f742b3ffbfa$export$f7ad0328861e2f03; }, function (v) { return $f95c4f742b3ffbfa$export$f7ad0328861e2f03 = v; });
var $f95c4f742b3ffbfa$export$6503ec6e8aabbaf;
var $f95c4f742b3ffbfa$export$f7ad0328861e2f03;
"use strict";
var $f95c4f742b3ffbfa$var$mapping = new Map();
function $f95c4f742b3ffbfa$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f95c4f742b3ffbfa$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f95c4f742b3ffbfa$var$resolve(id) {
    var resolved = $f95c4f742b3ffbfa$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f95c4f742b3ffbfa$export$6503ec6e8aabbaf = $f95c4f742b3ffbfa$var$register;
$f95c4f742b3ffbfa$export$f7ad0328861e2f03 = $f95c4f742b3ffbfa$var$resolve;

});

parcelRegister("dnjFL", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $9bccaeea68464283$export$bdfd709ae4826697; }, function (v) { return $9bccaeea68464283$export$bdfd709ae4826697 = v; });
var $9bccaeea68464283$export$bdfd709ae4826697;
var $9bccaeea68464283$export$c9e73fbda7da57b6;
var $9bccaeea68464283$export$5a759dc7a1cfb72a;
"use strict";
var $9bccaeea68464283$var$bundleURL = {};
function $9bccaeea68464283$var$getBundleURLCached(id) {
    var value = $9bccaeea68464283$var$bundleURL[id];
    if (!value) {
        value = $9bccaeea68464283$var$getBundleURL();
        $9bccaeea68464283$var$bundleURL[id] = value;
    }
    return value;
}
function $9bccaeea68464283$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $9bccaeea68464283$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $9bccaeea68464283$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $9bccaeea68464283$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$9bccaeea68464283$export$bdfd709ae4826697 = $9bccaeea68464283$var$getBundleURLCached;
$9bccaeea68464283$export$c9e73fbda7da57b6 = $9bccaeea68464283$var$getBaseURL;
$9bccaeea68464283$export$5a759dc7a1cfb72a = $9bccaeea68464283$var$getOrigin;

});

var $d48b3059eb8c8ea8$exports = {};


(parcelRequire("lpl75")).register((parcelRequire("dnjFL")).getBundleURL("5mVvh"), JSON.parse('["5mVvh","index.7b391cca.js","8jTGL","Instamart.3daeabcf.js"]'));

})();
//# sourceMappingURL=index.runtime.14d8374e.js.map
